import clsx from 'clsx';
import { appRoutes, ROUTE_VALIDATION } from '../../routes';
import { Link, NavLink } from 'react-router-dom';
import { IconButton, List, ListItem } from '@material-ui/core';
import { Dashboard } from '@material-ui/icons';
import { Divider } from '../Divider';
import { useAppView } from '../../contexts/AppViewContext';

interface Props {
  activeMenu: string;
  isMobile: boolean;
  onMenuOpen(open: boolean): void;
  operator: OperatorContext;
  setActiveMenu(item: string): void;
  user: UserContext;
  loading: boolean;
}

export const NavigationMenu = ({
  activeMenu,
  setActiveMenu,
  isMobile,
  user,
  operator,
  onMenuOpen,
  loading,
}: Props) => {
  const appView = useAppView();

  return (
    <nav
      className={clsx(
        'relative flex items-center h-full w-full overflow-x-auto overflow-y-hidden hide-scrollbar',
        { 'flex-col': isMobile }
      )}
    >
      <IconButton
        className="!text-white !m-[5px] bg-transparent hover:opacity-70 hover:text-white hover:!bg-transparent focus:opacity-70 focus:!text-white focus:!bg-transparent active:opacity-70 active:!text-white active:!bg-transparent"
        component={Link}
        onClick={() => {
          setActiveMenu('Dashboard');
          onMenuOpen(false);
        }}
        to="/"
        disableRipple
        disabled={loading}
      >
        <Dashboard />
      </IconButton>
      <Divider
        orientation={isMobile ? 'horizontal' : 'vertical'}
        colorMode="dark"
      />
      <List
        className={clsx('flex gap-1 text-white p-0 h-full w-full', {
          'flex-col': isMobile,
        })}
      >
        {appRoutes.reduce((arr: JSX.Element[], route) => {
          const isValidRoute = ROUTE_VALIDATION(route, appView, operator, user);
          const validSubRoutes = route.subRoutes
            ? route.subRoutes.some((r) =>
                ROUTE_VALIDATION(r, appView, operator, user)
              )
            : true;

          if (!isValidRoute || route.hidden || !validSubRoutes) return arr;

          arr.push(
            <ListItem
              key={route.path}
              alignItems="center"
              className={clsx('basis-0', {
                'relative after:absolute after:-bottom-2 after:left-0 after:h-1 after:w-full after:border-b-4 after:border-primary':
                  route.navbarName === activeMenu && !isMobile,
                'relative after:absolute after:bottom-0 after:left-0 after:w-1 after:h-full after:border-l-4 after:border-primary':
                  route.navbarName === activeMenu && isMobile,
              })}
            >
              <NavLink
                className={clsx(
                  'inherit justify-center !text-white whitespace-nowrap w-full hover:!text-white hover:opacity-70',
                  { 'pointer-events-none opacity-30': loading }
                )}
                to={route.path}
                onClick={() => {
                  setActiveMenu(route.navbarName);
                  onMenuOpen(false);
                }}
              >
                {route.navbarName}
              </NavLink>
            </ListItem>
          );
          return arr;
        }, [])}
      </List>
    </nav>
  );
};
